// Efficiency calculation utilities for CompareMode

// Calculate efficiency comparison between custom and auto paths
export const calculateEfficiency = (customDist, autoDist) => {
  if (!customDist || !autoDist) return { value: 0, better: false };
  
  const diff = customDist - autoDist;
  const percent = (diff / autoDist) * 100;
  
  return {
    value: Math.abs(percent),
    better: diff < 0
  };
};

// Calculate path difference statistics
export const calculatePathDifference = (customPathInfo, autoPathInfo) => {
  if (!autoPathInfo || !customPathInfo) return null;
  
  const distanceDiff = customPathInfo.distance - autoPathInfo.distance;
  const percentDiff = (distanceDiff / autoPathInfo.distance) * 100;
  
  return {
    absoluteDiff: Math.abs(distanceDiff),
    percentDiff: percentDiff,
    isCustomBetter: distanceDiff < 0
  };
}; 